import { db } from "../firebase";
import { collection, addDoc, getDocs, query, orderBy, limit, serverTimestamp } from "firebase/firestore";

/* Histórico de cálculos — cada vez que um cálculo é "aplicado" (registrar
   produto, adicionar ao orçamento, ou aplicar a margem em massa no wizard),
   fica salvo um retrato do que foi calculado, pra poder reaplicar depois
   sem digitar tudo de novo. Não é o orçamento/produto em si — só um log. */

export async function salvarHistoricoCalculo(uid, { custoTotal, custosAdicionaisTotal, precoFinal, margemReal, markup, taxaTotalPct, origem }) {
  try {
    await addDoc(collection(db, `users/${uid}/historico_calculos`), {
      custoTotal: parseFloat(custoTotal.toFixed(2)),
      custosAdicionaisTotal: parseFloat((custosAdicionaisTotal||0).toFixed(2)),
      precoFinal: parseFloat(precoFinal.toFixed(2)),
      margemReal: parseFloat(margemReal.toFixed(2)),
      markup: parseFloat(markup.toFixed(2)),
      taxaTotalPct: parseFloat((taxaTotalPct||0).toFixed(2)),
      origem: origem || "calculo", // 'calculo' | 'produto' | 'orcamento'
      criado_em: serverTimestamp(),
    });
  } catch (e) { console.error("Erro ao salvar histórico de cálculo:", e); }
}

export async function listarHistoricoCalculos(uid, max = 50) {
  try {
    const snap = await getDocs(query(collection(db, `users/${uid}/historico_calculos`), orderBy("criado_em", "desc"), limit(max)));
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  } catch {
    // Índice/campo pode não existir ainda em contas antigas — cai pro sem-ordenar.
    try {
      const snap = await getDocs(collection(db, `users/${uid}/historico_calculos`));
      return snap.docs.map(d => ({ id: d.id, ...d.data() }));
    } catch { return []; }
  }
}
